// utils/propertyUtils.js
import { PROPERTY_STATUS_MAP } from "../../constants/admin/property/propertyConstants";

export const createPropertyFormData = (
  property
) => {
  const images =
    typeof property.images === "string"
      ? JSON.parse(property.images)
      : property.images || [];

  return {
    ...property,
    images,
  };
};

export const buildPropertyPayload = ({
  formData,
  uploadedImages,
}) => ({
  ...formData,
  price: formData.price
    ? Number(formData.price)
    : null,

  rentPrice: formData.rentPrice
    ? Number(formData.rentPrice)
    : null,

  area: formData.area
    ? Number(formData.area)
    : null,

  floor: formData.floor
    ? Number(formData.floor)
    : null,

  bedrooms: formData.bedrooms
    ? Number(formData.bedrooms)
    : null,

  bathrooms: formData.bathrooms
    ? Number(formData.bathrooms)
    : null,

  latitude: formData.latitude
    ? Number(formData.latitude)
    : null,

  longitude: formData.longitude
    ? Number(formData.longitude)
    : null,

  images:
    uploadedImages.length > 0
      ? uploadedImages
      : formData.images,
});

export const getPropertyStatus = (
  status
) =>
  PROPERTY_STATUS_MAP[status] || {
    label: status,
    className: "text-gray-500",
  };

  // utils/propertyValidation.js

  export const validatePropertyForm = (
    formData,
    imageFiles,
    editingProperty
  ) => {
    const errors = {};
  
    if (!formData.projectId) {
      errors.projectId = "Vui lòng chọn dự án";
    }
  
    if (!formData.title?.trim()) {
      errors.title = "Tiêu đề không được để trống";
    }
  
    if (!formData.propertyType) {
      errors.propertyType =
        "Vui lòng chọn loại bất động sản";
    }
  
    if (!formData.transactionType) {
      errors.transactionType =
        "Vui lòng chọn loại giao dịch";
    }
  
    if (
      formData.transactionType === "sale" &&
      (!formData.price ||
        Number(formData.price) <= 0)
    ) {
      errors.price = "Giá bán phải lớn hơn 0";
    }
  
    if (
      formData.transactionType === "rent" &&
      (!formData.rentPrice ||
        Number(formData.rentPrice) <= 0)
    ) {
      errors.rentPrice =
        "Giá thuê phải lớn hơn 0";
    }
  
    if (
      !formData.area ||
      Number(formData.area) <= 0
    ) {
      errors.area =
        "Diện tích phải lớn hơn 0";
    }
  
    if (!formData.location?.trim()) {
      errors.location =
        "Vui lòng nhập vị trí";
    }
  
    if (
      !editingProperty &&
      imageFiles.length === 0
    ) {
      errors.images =
        "Vui lòng chọn ít nhất 1 hình ảnh";
    }
  
    return errors;
  };